import api from "../utils/api.js";
import { trackEvent } from '../utils/tracking'; 
import { getImageAsBlob, delay } from '../utils';

export const share = {
    namespaced: true,
    state: {
        loadingStatus: false,
        imageUrl: null,
        imageData: null,
        sharableUrl: null,
        shareData: null,
        modalOpened: false,
        sharedId: 0,
        shareType: null,
    },
    getters: {
        getLoadingStatus(state) {
            return state.loadingStatus;
        },
        imageUrl(state) {
            return state.imageUrl;
        },
        isShareModalOpened(state) {
            return state.modalOpened;
        },
        shareType(state) {
            return state.shareType;
        },
        sharedId(state) {
            return state.sharedId;
        },
    },
    mutations: {
        setLoadingStatus(state, status){
            state.loadingStatus = status;
        },
        setUrl(state, payload) {
            const { type, id, urlType = '', url: payloadUrl = '' } = payload;
            let url = ''; 

            switch(type) {
                case 'invite':
                    break;
                case 'cart':
                    url = encodeURI(`${SOCIAL_HOST}cart${urlType}/${id}`);
                    break;
                case 'product':
                    if(urlType === 'image' && payloadUrl.length > 0) {
                        url = payloadUrl;
                    } else if(urlType !== 'image'){
                        url = encodeURI(`${SOCIAL_HOST}product${urlType}/${id}`);
                    }
                    break;
                case 'outfit':
                default:
                    url = encodeURI(`${SOCIAL_HOST}outfit${urlType}/${id}`);
                    break;
            }

            if(url) state[`${urlType || 'sharable'}Url`] = url;
            state.sharedId = id;
            state.shareType = type;
        },
        setShareData(state, payload) {
            state.shareData = payload;
        },
        setImageData(state, payload) {
            state.imageData = payload;
        },
        setSharedId(state, sharedId) {
            state.sharedId = sharedId;
        },
        setShareType(state, type) {
            state.shareType = type;
        },
        openShareModal(state) {
            state.modalOpened = true;
        },
        closeShareModal(state) {
            state.modalOpened = false;
        }
    },
    actions: {
        async instagram(context, payload) {
            if(payload) {
                const { type, id } = payload;
                if(type && id) context.dispatch('setUrl', { type, id });
            }

            context.dispatch('firebaseShare');

            const { shareData, imageData, sharableUrl } = context.state;

            if(!imageData.done) context.commit('setLoadingStatus', true);
                
            const promise = imageData.done ? imageData : delay(imageData, 400);

            return promise.then((data) => {
                    IGStory.shareToStory(
                        {
                            backgroundImage: '',
                            attributionURL: sharableUrl,
                            backgroundTopColor: '#ffffff',
                            backgroundBottomColor: '#ffffff',
                            stickerImage: data && data.replace(/data:image\/(png|jpeg);base64,/, ""),
                        },
                        success => { },
                        err => { }
                    );
                })
                .finally(() => {
                    context.commit('setLoadingStatus', false);
                });
        },
        facebook(context) {
            const { shareData, sharableUrl, imageUrl } = context.state;
            const defaultMessage = `Visit ${shareData.social_media_links.facebook}`;
            
            context.dispatch('firebaseShare');
            context.commit('setLoadingStatus', true);

            return new Promise((resolve, reject) => {
                facebookConnectPlugin.showDialog( 
                    {
                        method: "feed",
                        href: sharableUrl,
                        picture: imageUrl,
                        message: shareData.message || defaultMessage,
                        hashtag: shareData.hashtags,
                        quote: shareData.quote,
                    }, 
                    function (response) { resolve(response) },
                    function (response) { reject(response) }
                );
            }).finally(() => {
                context.commit('setLoadingStatus', false);
            });
        },
        sms(context) {
            const { shareData, shareType, imageData } = context.state;
            const defaultMessage = 'Check this cool outfit from \\' + shareData.social_media_links.app_store;
            const message = (() => {
                switch(shareType) {
                    case 'cart':
                        return shareData.sms_body_cart;
                    case 'outfit':
                        return shareData.sms_body;
                    case 'product':
                            return shareData.sms_body_product;
                    case 'invite':
                        return shareData.sms_invite_friends;
                }
            })() || defaultMessage;

            context.dispatch('firebaseShare');
                
            if(!imageData.done) context.commit('setLoadingStatus', true);
                
            const promise = imageData.done ? imageData : delay(imageData, 400);
            
            return promise.then((data) => {
                    window.plugins.socialsharing.shareViaSMS(
                        {
                            message,
                            subject: 'The Mada App',
                            image: data && data.replace(/data:image\/(png|jpeg);base64,/, ""),
                        }, 
                        null, 
                        () => {  }, 
                        () => {  },
                    );
                })
                .finally(() => {
                    context.commit('setLoadingStatus', false);
                });
        },
        fetchShareData(context) {
            return api.get(`${api.socialUri()}sharedata`)
                .then(response => {
                    context.commit('setShareData', response);
                })
                .catch((err) =>{ throw err })
        },
        setUrl(context, payload) {
            context.commit('setUrl', { ...payload, urlType: 'image' });
            context.commit('setUrl', payload);
            const { imageUrl } = context.state;

            const promise = imageUrl ? getImageAsBlob(imageUrl)
                .then((data) => {
                    promise.done = true;
                    return data;
                }) : Promise.resolve(null);
            context.commit('setImageData', promise);
        },
        firebaseShare(context) {
            const { shareId: content_id, shareType: type = 'outfit' } = context.state;
            trackEvent(`share_${type}`, { content_id });
        },
    }
};
